import {
  GENERATION_TOOL,
  GENERATION_TOOL_GROUP,
  getGroupByTool,
  getToolGroupTitle,
  isBasicContentImproverTool,
  isImageGenerationTool,
  isRewriteGenerationTool,
} from 'src/data/generationTool';

import { SIDEBAR_GENERIC_ITEM, SIDEBAR_TOOL_GROUPS } from '../const';

export const isSidebarToolGroupItem = (sidebarItem) =>
  Object.values(GENERATION_TOOL_GROUP).includes(sidebarItem);

export const getSidebarItemFromGenerationTool = (generationTool) => {
  if (!generationTool) {
    return null;
  }

  if (generationTool === GENERATION_TOOL.customMultiPrompt) {
    return GENERATION_TOOL_GROUP.customMultiPrompt;
  }

  // We check "freestyle" separately, cause tool group still has "create your own" in it
  if (generationTool === GENERATION_TOOL.freestyle) {
    return GENERATION_TOOL_GROUP.anyCopy;
  }

  // all "new" "image" generation tools should end up in the "images" group
  // NOTE: some of the image tools are "rewrite" tools, so we check for "image" group first
  if (
    isImageGenerationTool(generationTool) &&
    generationTool !== GENERATION_TOOL.imageWithDescription
  ) {
    return GENERATION_TOOL_GROUP.images;
  }

  // since rewrite tools are scattered between different groups and come code depends on these groups,
  // for now navigate rewrite tools to boost group.
  // later we may move them to the boost group
  // note: GENERATION_TOOL.basicContentImprover was moved to GENERATION_TOOL_GROUP.boost so the next if condition works for it
  if (isRewriteGenerationTool(generationTool) || isBasicContentImproverTool(generationTool)) {
    return GENERATION_TOOL_GROUP.boost;
  }

  const toolGroup = getGroupByTool(generationTool);
  if (SIDEBAR_TOOL_GROUPS.includes(toolGroup)) {
    return toolGroup;
  }

  return SIDEBAR_GENERIC_ITEM.moreItems;
};

export const getSidebarTitle = (sidebarItem) => {
  if (isSidebarToolGroupItem(sidebarItem)) {
    const groupTitle =
      sidebarItem === GENERATION_TOOL_GROUP.ads ? 'Ad' : getToolGroupTitle(sidebarItem);
    if (sidebarItem === GENERATION_TOOL_GROUP.customMultiPrompt) {
      return groupTitle;
    }

    return `${groupTitle} Templates`;
  }

  switch (sidebarItem) {
    case SIDEBAR_GENERIC_ITEM.search:
      return 'All Templates';

    case SIDEBAR_GENERIC_ITEM.recentlyUsed:
      return 'Recently Used Templates';

    case SIDEBAR_GENERIC_ITEM.moreItems:
      return 'More';

    default:
      return '';
  }
};

export const getLeftPanelSearchHint = (sidebarItem) => {
  if ([SIDEBAR_GENERIC_ITEM.search, SIDEBAR_GENERIC_ITEM.recentlyUsed].includes(sidebarItem)) {
    return 'Try “headline” or “facebook”';
  }
  return 'Try "AIDA" or "headline"';
};
